import { render, staticRenderFns } from "./SettingsPanel.vue?vue&type=template&id=39407a6e&scoped=true"
import script from "./SettingsPanel.vue?vue&type=script&lang=js"
export * from "./SettingsPanel.vue?vue&type=script&lang=js"
import style0 from "./SettingsPanel.vue?vue&type=style&index=0&id=39407a6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39407a6e",
  null
  
)

export default component.exports